<template>
  <portal to="iqos-modal-portal">
    <div class="modal-backdrop"></div>
    <div class="modal-wrapper">
      <div class="modal-header">
        <div class="gap-row-zero w-100">
          <div class="qrw-heading-xs bold v1-grey-10-color">
            {{ $t("updated_language_modal.title") }}
          </div>
          <div class="qrw-label-sm v1-grey-7-color">
            {{
              isSettingOriginal
                ? $t("updated_language_modal.subtitle_original")
                : $t("updated_language_modal.subtitle")
            }}
          </div>
        </div>
        <BaseButton
          variant="tertiary"
          @click="$emit('close')"
          size="lg"
          icon="x"
          color="v1-grey-10"
        />
      </div>
      <div class="modal-body">
        <BaseInput
          :placeholder="$t('updated_language_modal.search')"
          icon="search"
          fullWidth
          v-model="search"
        />

        <div class="languages-grid">
          <div
            class="language-card"
            @click="toggleLocale(key)"
            :class="{
              selected: isSelected(key),
            }"
            v-for="(name, key) in availableLanguges"
            :key="key"
          >
            <img :src="`/flags/${key}.png`" />
            <div
              class="qrw-heading-xs"
              :class="{
                'white-color bold': isSelected(key),
                'v1-grey-10-color': !isSelected(key),
              }"
            >
              {{ name }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer set-original" v-if="isSettingOriginal">
        <BaseButton
          @click="onConfirm"
          variant="primary"
          class="nowrap"
          :disabled="selected.length == 0"
          color="green-5"
          size="md"
          icon="plus"
          bold
        >
          {{ $t("updated_language_modal.set_original") }}
        </BaseButton>
      </div>
      <div class="modal-footer" v-else>
        <div class="qrw-label-lg v1-grey-6-color bold w-100">
          {{
            selected.length
              ? $tc("updated_language_modal.languages_plural", selected.length)
              : ""
          }}
        </div>

        <BaseButton
          @click="onConfirm"
          variant="primary"
          class="nowrap"
          :disabled="selected.length == 0"
          color="green-5"
          size="md"
          icon="plus"
          bold
        >
          {{ $t("updated_language_modal.btn_add") }}
        </BaseButton>
      </div>
    </div>
  </portal>
</template>

<script>
import LanguageNames from "@/i18n/language_names.js";

export default {
  data() {
    return {
      search: null,

      selected: [],
    };
  },
  props: {
    exclude: Array,
    forOriginal: Boolean,
  },
  methods: {
    isSelected(locale) {
      return this.selected.includes(locale);
    },
    toggleLocale(locale) {
      if (this.isSettingOriginal) {
        this.selected = [locale];
        return;
      }

      if (this.isSelected(locale)) {
        this.selected = this.selected.filter((l) => l != locale);
      } else {
        this.selected.push(locale);
      }
    },
    onConfirm() {
      this.$emit("select", this.selected);
      this.$emit("close");
    },
  },
  computed: {
    isSettingOriginal() {
      return this.exclude.length === 0 || this.forOriginal;
    },
    availableLanguges() {
      const langs = Object.assign({}, LanguageNames);

      if (this.exclude) this.exclude.forEach((l) => delete langs[l]);

      if (this.search) {
        Object.entries(langs).forEach((e) => {
          if (
            !`${e[0]}/${e[1]}`.toLowerCase().includes(this.search.toLowerCase())
          ) {
            delete langs[e[0]];
          }
        });
      }

      return langs;
    },
  },
};
</script>

<style scoped>
.modal-header {
  background: var(--v1-grey-2-color);
  padding: 16px 16px 16px 24px;
  display: flex;
  flex-direction: row;
  column-gap: 16px;
}

.modal-wrapper {
  border-radius: 8px;
  overflow: hidden;

  z-index: 15;
  position: fixed;
  top: 50%;
  left: 50%;

  width: 1000px;

  transform: translate(-50%, -50%);

  background: var(--v1-grey-1-color);
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  background: var(--v1-grey-1-color);
  height: calc(100vh * 0.42);
  min-height: calc(100vh * 0.42);
  overflow: auto;
}

.languages-grid {
  display: flex;
  row-gap: 8px;
  column-gap: 8px;
  flex-wrap: wrap;
}

.language-card {
  padding: 8px 16px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;

  cursor: pointer;

  flex: 1 1 calc(33% - 8px);
}

.language-card img {
  width: 16px;
  height: 16px;
  max-width: 16px;
  max-height: 16px;
  min-width: 16px;
  min-height: 16px;
}

.language-card:hover {
  background: var(--v1-grey-2-color);
}

.language-card.selected {
  background: var(--v1-grey-10-color);
}

.modal-footer {
  background: var(--v1-grey-2-color);
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;

  background: rgba(0, 0, 0, 0.24);

  width: 100vw;
  height: 100vh;
  z-index: 10;
}

.set-original {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
